const selectV2InjectionKey = "ElSelectV2Injection";

export { selectV2InjectionKey };
//# sourceMappingURL=token.mjs.map
